import { inject, observer } from "mobx-react";
import React from "react";

import { ICurrentUserStore } from "../models/currentUser/CurrentUserStore";
import { CloserWidget } from "./closerWidget";

interface Props {
  currentUserStore?: ICurrentUserStore;
}

export const WidgetWrapper: React.SFC<Props> = inject("currentUserStore")(
  observer((props: Props) => {
    return <>{props.currentUserStore!.widgetEnabled && <CloserWidget />}</>;
  })
);
